<template>
    <modal
            v-model="modal"
            :modal-title="getTranslation('selectAddress')"
            :ok-button-label="getTranslation('save')"
            :cancel-button-label="getTranslation('cancel')"
            @ok-button-click="saveAddress"
    >
        <div class="form__group">
            <label class="form__label  form__label--block">{{ getTranslation('ate') }}</label>
            <v-select
                    v-if="loadSelects"
                    v-model="form.ateId"
                    :options="ates"
                    :reduce="option => option.id"
                    label="title"
                    :placeholder="getTranslation('selectFromList')"
                    @input="fetchStreets"
                    :class="{ 'field--error': $v.form.ateId.$error }"
                    @search:blur="$v.form.ateId.$touch()"
            />
            <div v-if="$v.form.ateId.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>
        <div v-if="form.ateId" class="form__group">
            <label class="form__label  form__label--block">{{ getTranslation('street') }}</label>
            <v-select
                    v-if="loadSelects"
                    v-model="form.streetId"
                    :options="streets"
                    :reduce="option => option.id"
                    label="title"
                    :placeholder="getTranslation('selectFromList')"
                    :class="{ 'field--error': $v.form.streetId.$error }"
                    @search:blur="$v.form.streetId.$touch()"
            />
            <div v-if="$v.form.streetId.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div v-if="form.streetId" class="form__group">
                    <label for="address-modal-house-id" class="form__label  form__label--block">{{ getTranslation('house') }}</label>
                    <input @blur="$v.form.houseTxt.$touch()" id="address-modal-house-id" v-model="form.houseTxt" :placeholder="getTranslation('house')" type="text" class="field  field--full-width" :class="{ 'field--error': $v.form.houseTxt.$error }"/>
                    <div v-if="$v.form.houseTxt.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
                </div>
            </div>
            <div class="col-md-6">
                <div v-if="form.streetId" class="col-md-6">
                    <div class="form__group">
                        <label for="address-modal-flat-id" class="form__label  form__label--block">{{ getTranslation('flat') }}</label>
                        <input id="address-modal-flat-id" v-model="form.flatTxt" :placeholder="getTranslation('flat')" type="text" class="field  field--full-width"/>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import {required} from 'vuelidate/lib/validators'

    export default {
        props: {
            type: String,
            toggle: Boolean
        },
        data() {
            return {
                modal: false,
                streets: [],
                form: {
                    ateId: '',
                    streetId: '',
                    houseTxt: '',
                    flatTxt: '',
                    fullAddress: ''
                },
                loadSelects: false
            }
        },
        validations: {
            form: {
                ateId: {
                    required
                },
                streetId: {
                    required
                },
                houseTxt: {
                    required
                }
            }
        },
        computed: {
            ates() {
                return this.$store.getters.getAtes;
            }
        },
        watch: {
            modal(status) {
                this.$emit('update:toggle', status);
            },
            toggle(status) {
                if (this.modal !== status) this.modal = status;
            },
            'form.ateId'() {
                if (this.form.streetId) {
                    this.form.streetId = '';
                    this.loadSelects = false;
                    setTimeout(() => {
                        this.loadSelects = true;
                    }, 300);
                }
            }
        },
        async created() {
            this.modal = this.toggle;
            await this.$store.dispatch('fetchAtes');
            this.loadSelects = true;
        },
        methods: {
            fetchStreets(id) {
                return this.axios.get(this.$config.urls.office.fetchAddressStreetsByKeyAtesh.url, {
                    params: {key_ates: id}
                }).then(response => {
                    this.streets = this.objectToArray(response.data.data);
                });
            },
            saveAddress() {
                this.$v.form.$touch();
                if (this.$v.form.$invalid) {
                    this.$snotify.error(this.getTranslation('wrongFormMsg'));
                } else {
                    this.axios.get(this.$config.urls.office.fetchAddressFullName.url, {
                        params: {street_id: this.form.streetId}
                    }).then(response => {
                        this.form.fullAddress = response.data.data.text + ', ' + this.getTranslation('houseSmall') + this.form.houseTxt;
                        if (this.form.flatTxt) this.form.fullAddress = this.form.fullAddress + ', ' + this.getTranslation('flatShort') + ' ' + this.form.flatTxt;
                        this.$emit('input', this.form);
                        this.modal = false;
                    });
                }
            }
        }

    }
</script>